{
    "services-money-transfers": {
        "meta": {
            "title": "La Mejor App Para Mandar Dinero sin Costos Ocultos - MAJORITY",
            "description": "¿Buscas la mejor app Internacional para mandar dinero alrededor del Mundo? Prueba la app de MAJORITY sin costos ocultos. Lee más"
        },
        "hero": {
            "title": "Transferencias de dinero al exterior con entrega rápida y segura",
            "body": "Descubre cómo enviar una transferencia de dinero al exterior sin cargos extra.",
            "cta": "Yo envío dinero a",
            "features": "Tipos de cambio competitivos\nLímites amplios para tus envíos de dinero"
        },
        "send_save_more_content_box": {
            "tagline": "Envío de dinero",
            "title": "Envía más y ahorra más",
            "body": "Puedes hacer una transferencia de dinero al exterior sin cargos ocultos. Eso significa que gastas cada vez menos para enviar dinero a tu familia en el extranjero.",
            "canvas": "Tipos de cambio increíbles"
        },
        "exchange_rates_content_box": {
            "tagline": "Envío de dinero",
            "title": "Descubre nuestros tipos de cambio increíbles para enviar dinero",
            "body": "Te ayudamos a ahorrar al hacer una transferencia de dinero al exterior ofreciéndote tipos de cambio competitivos a todos los países."
        }
    }
    
}